export const orgUserGroup = {
  header: 'Tous les groupes d\'utilisateurs ({{count}})',
  disabled: '(désactivé)',
  uid: 'Code',
  name: 'Nom',
  unit: 'Unité',
  orgUnit: 'Unité',
  actions: '',
  sortBy: 'Trier par',
  sort: {
    byName: 'Nom',
    byUnitName: 'Unité',
    byGroupID: 'Groupe',
  },
  hint: 'Les groupes d\'utilisateurs vous permettent de regrouper des utilisateurs pour assigner des limites d\'achat à plusieurs utilisateurs à la fois.',
  details: {
    title: 'Détails du groupe d\'utilisateurs',
    subtitle: 'Groupe d\'utilisateurs : {{ item.name }}',
  },
  edit: {
    title: 'Modifier le groupe d\'utilisateurs',
    subtitle: 'Groupe d\'utilisateurs : {{ item.name }}',
  },
  create: {
    title: 'Créer un groupe d\'utilisateurs',
    subtitle: '',
  },
  links: {
    user: 'Utilisateurs',
    permission: 'Limites d\'achat',
  },
  messages: {
    update: 'Groupe d\'utilisateurs {{ item.name }} mis à jour avec succès',
    create: 'Groupe d\'utilisateurs {{ item.name }} créé avec succès',
    deleteTitle: 'Supprimer ce groupe d\'utilisateurs?',
    delete: 'Les utilisateurs de ce groupe ne sont pas affectés lorsque le groupe est supprimé.',
    deleted: 'Groupe d\'utilisateurs {{ item.name }} supprimé avec succès',
  },
  breadcrumbs: {
    list: 'Tous les groupes d\'utilisateurs',
    details: '{{name}}',
    users: 'Utilisateurs',
    permissions: 'Limites d\'achat',
  },
};

export const orgUserGroupAssignedUsers = {
  title: 'Utilisateurs assignés',
  subtitle: 'Groupe d\'utilisateurs : {{ item.name }}',
  assigned: 'Utilisateur {{item.name}} assigné avec succès',
  unassigned: 'Utilisateur {{item.name}} désassigné avec succès',
};

export const orgUserGroupUsers = {
  title: 'Gérer les utilisateurs',
  subtitle: 'Groupe d\'utilisateurs : {{ item.name }}',
  assigned: 'Utilisateur {{item.name}} assigné avec succès',
  unassigned: 'Utilisateur {{item.name}} désassigné avec succès',
  unassignAll: 'Désassigner tous',
  unassignAllConfirmation: 'Tous les utilisateurs ont été désassignés avec succès',
};
export const orgUserGroupAssignedPermissions = {
  title: 'Limites d\'achat assignées',
  subtitle: 'Limite : {{ item.name }}',
  assigned: 'Limite d\'achat {{item.code}} assignée avec succès',
  unassigned: 'Limite d\'achat {{item.code}} désassignée avec succès',
};

export const orgUserGroupPermissions = {
  title: 'Gérer les limites d\'achat',
  subtitle: 'Limite : {{ item.name }}',
  assigned: 'Limite d\'achat {{item.code}} assignée avec succès',
  unassigned: 'Limite d\'achat {{item.code}} désassignée avec succès',
};
